//components
import { ISimpleTableProps, SimpleTable} from 'thrive-components';


const RegisteredPasskeysData = ({registeredPasskeysTableContent} : {registeredPasskeysTableContent: ISimpleTableProps}) => {  
    return(
        <div className='registered-passkeys-data'>
            <label className='passkey-label'>
                REGISTERED PASSKEYS
            </label>

            <SimpleTable 
                {...registeredPasskeysTableContent}
            />  
        </div>
    )
}

export default RegisteredPasskeysData